export default __webpack_public_path__ + "static/media/total-volume.88928385.png";